<div class="lvi-content">
    <div class="avatar">
        <i class="material-icons-outlined">credit_card</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="onItemClick()">{{ data.numCarteClair }}</a>
        </div>
        <ul class="lvi-attrs">
            <li *ngIf="data.dateFin"><strong [translate]="'admin.frais.fournisseurs.compte.validite'"></strong> {{ data.dateFin | date:'shortDate'}} </li>
            <li><strong [translate]="'admin.frais.fournisseurs.compte.collaborateur'"></strong> {{ data.user.prenom }} {{ data.user.nom }} ({{data.user.matricule}})</li>
            <li *ngIf="data.typeDebit"><strong [translate]="'admin.frais.fournisseurs.compte.debitSur'"></strong> {{ data.typeDebit }} </li>
            <li><strong [translate]="'admin.frais.fournisseurs.compte.actif'"></strong> {{ getStatutCompte() }} </li>
        </ul>
    </div>
</div>
